import { Link } from 'react-router-dom';

import { EmptyStatePanel } from '@/designSystem/molecules/EmptyStatePanel';

/**
 * Agent catalog stub (tenant-scoped list ships in Phase 5).
 */
export function AgentsListPage() {
  return (
    <div data-testid="agents-agents-list">
      <header data-testid="agents-agents-list-header" className="mb-6">
        <h1 className="text-2xl font-semibold text-primary">Agents</h1>
        <p className="mt-2 text-secondary">Browse and manage agents for your company workspace.</p>
      </header>

      <EmptyStatePanel
        data-testid="agents-agents-list-empty-state"
        icon="SquaresFour"
        title="No agents yet"
        description="The agent catalog and create flow will appear here. Deep links to individual agents are already routed for future builder work."
      >
        <Link to="/agents/demo-agent" data-testid="agents-agents-list-demo-link" className="ds-link">
          Preview agent detail stub
        </Link>
      </EmptyStatePanel>
    </div>
  );
}
